import { FilterFunction, initAsyncSlice } from 'aa_common/front-end/zustand'
import { NetsuiteService, PresenterNetsuiteStatusResponse } from 'common/open-api'

const initFilter = {}
const initState: PresenterNetsuiteStatusResponse = {}

const fetchData: FilterFunction<typeof initState, typeof initFilter> = async () => {
  return NetsuiteService.getNetsuiteStatus()
}

export const netsuiteStatusStore = initAsyncSlice<typeof initState, typeof initFilter>(
  'setting/netsuite-linkage-status',
  initState,
  initFilter,
  fetchData
)
